

import router from '@/router';
export default {
  props: {
    title: String,
    content:String
  },
  setup() {
    const goHomeFn = () => {
      router.push({
        path:'/home' 
        
      })
    }
    return {
      goHomeFn
    }
  }
}
